import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  documentBox: {},
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
  documentHeadText: {
    color: theme.palette.grey[600],
    fontSize: 18,
    letterSpacing: 0.3,
    marginBottom: 20,
  },
  accordionBox: {
    marginBottom: 20,
    borderRadius: 5,
    border: '1px solid #dedede',
    '&:before': {
      display: 'none',
    },
    '& .MuiAccordionSummary-root': {
      flexDirection: 'row-reverse',
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 48,
    },
    '&.MuiAccordion-root.Mui-expanded': {
      margin: 0,
      marginBottom: 20,
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
    '& .MuiIconButton-edgeEnd': {
      marginRight: 0,
    },
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  accoheading: {
    fontSize: 16,
    letterSpacing: 0.3,
    fontWeight: 600,
    color: theme.palette.grey[500],
  },
  table: {},
  documentNameText: {
    width: '30%',
  },
  downloadIconCell: {
    paddingRight: '5%',
  },
  downloadIcon: {
    fill: theme.palette.grey[50],
  },
}));
